import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const budgetPreviews = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 32px;
`

export const TabsBox = styled(Box)`
  display: flex;
  justify-content: flex-end;
`

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 32px;
    margin-top: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: column-reverse;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
    }
  `}
`

export const FilterButtons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-end;
    gap: 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      margin-top: 16px;
      flex-direction: column-reverse;
      align-items: center;
    }
  `}
`
